import { useRef } from 'react';
import { useAccordionContext } from '../use-accordion-context';
export var useAccordionRef = function useAccordionRef() {
  var ref = useRef(null);

  var _useAccordionContext = useAccordionContext(),
      isOpen = _useAccordionContext.isOpen;

  var isExpanded = isOpen(ref);
  return {
    isExpanded: isExpanded,
    ref: ref
  };
};